import {
  Avatar,
  Box,
  Button,
  Grid,
  LinearProgress,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { useTranslation } from "react-i18next";
import { getUserInfo } from "../../api/authentication/info/UserInfoAPI";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import SupervisedUserCircleRoundedIcon from "@mui/icons-material/SupervisedUserCircleRounded";
import ScheduleRoundedIcon from "@mui/icons-material/ScheduleRounded";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { FaCrown, FaShapes } from "react-icons/fa";
import timeSince from "../../util/TimeSince";

type SubscriptionProps = {
  type: string;
  expired?: string;
};

export function BasicUserInfo(props: any) {
  const { t } = useTranslation(["common", "plan", "user", "account"]);
  return (
    <List>
      <ListItem>
        <ListItemAvatar>
          <Avatar sx={{ background: "none" }}>
            <AlternateEmailIcon color="info" />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={t("account:email_address")}
          secondary={props.email ? props.email : "?"}
        ></ListItemText>
        <Button
          disabled
          variant="contained"
          style={{
            minWidth: "10px",
            margin: "10px",
          }}
          onClick={() => {}}
        >
          <EditRoundedIcon />
        </Button>
      </ListItem>
      <ListItem>
        <ListItemAvatar>
          <Avatar sx={{ background: "none" }}>
            <AccountCircleIcon color="info" />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={t("account:full_name")}
          secondary={props.name ? props.name : "?"}
        ></ListItemText>
        <Button
          variant="contained"
          style={{
            minWidth: "10px",
            margin: "10px",
          }}
          onClick={() => {}}
        >
          <EditRoundedIcon />
        </Button>
      </ListItem>
      <ListItem>
        <ListItemAvatar>
          <Avatar sx={{ background: "none" }}>
            <SupervisedUserCircleRoundedIcon color="info" />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={t("account:industry")}
          secondary={props.industry ? props.industry : "?"}
        ></ListItemText>
        <Button
          variant="contained"
          style={{
            minWidth: "10px",
            margin: "10px",
          }}
          onClick={() => {}}
        >
          <EditRoundedIcon />
        </Button>
      </ListItem>
      <ListItem>
        <ListItemAvatar>
          <Avatar sx={{ background: "none" }}>
            <ScheduleRoundedIcon color="info" />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={t("account:active_since")}
          secondary={
            props.createdAt
              ? new Date(props.createdAt).toLocaleDateString("vi-VN") +
                " (" +
                timeSince(props.createdAt) +
                ")"
              : "?"
          }
        ></ListItemText>
      </ListItem>
    </List>
  );
}

export function SubscriptionDisplay(props: any) {
  const { t } = useTranslation(["common", "plan"]);
  var icon = <FaCrown color="red" />;
  var barLength = 10;
  if (props.type == "NONE") {
    icon = <FaShapes color="red" />;
  }
  if (props.type == "BASIC") {
  }
  if (props.type == "PRO") {
  }
  if (props.type == "PREMIUM") {
    icon = <FaCrown color="gold" />;
  }
  return (
    <ListItem>
      <ListItemAvatar>
        <Avatar sx={{ background: "none" }}>{icon}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={t("plan:" + props.type).toUpperCase()}
        primaryTypographyProps={{ variant: "h6", fontWeight: 500 }}
        secondary={
          props.expired
            ? t("plan:expired_date") +
              ": " +
              new Date(props.expired).toLocaleDateString("vi-VN")
            : t("plan:never_expired")
        }
      ></ListItemText>
      <Box sx={{ width: "40%", marginRight: "20px" }}>
        <LinearProgress
          variant="determinate"
          color={props.color ? props.color : "success"}
          value={props.expired ? barLength : 100}
        />
      </Box>
      <Button
        variant="contained"
        style={{
          minWidth: "100px",
          margin: "10px",
          visibility: props.expired ? "visible" : "hidden",
        }}
        onClick={() => {}}
      >
        {t("plan:renew")}
      </Button>
    </ListItem>
  );
}

export function UserInfoPage() {
  const { t } = useTranslation(["common", "account"]);
  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    planType: "",
    createdAt: "",
    industry: "",
  });
  const [subscriptions, setSubscriptions] = useState([]);
  const [subscriptionOrders, setSubscriptionOrders] = useState([]);
  useEffect(() => {
    getUserInfo()
      .then((res) => {
        setUserInfo(res.userInfo);
        setSubscriptions(res.subscriptions);
        setSubscriptionOrders(res.subscriptionOrders);
      })
      .catch((err) => {});
  }, []);

  var subscriptionList = subscriptions.map((sub) => {
    return (
      <SubscriptionDisplay
        type={sub["planType"]}
        expired={sub["expiredDate"]}
      />
    );
  });
  return (
    <Grid container xs={12}>
      <Grid container xs={12}>
        <Grid xs={0.75}></Grid>
        <Grid xs={5} className="white">
          <Typography
            variant="h5"
            align="left"
            marginLeft={"15px"}
            marginTop={"5px"}
            fontWeight={600}
          >
            {t("account:info")}
          </Typography>
          <BasicUserInfo
            name={userInfo["name"]}
            email={userInfo["email"]}
            createdAt={userInfo["createdAt"]}
            industry={userInfo["industry"]}
          />
        </Grid>
        <Grid xs={0.5}></Grid>
        <Grid xs={5} className="white">
          <Typography
            variant="h5"
            align="left"
            marginLeft={"15px"}
            marginTop={"5px"}
            fontWeight={600}
          >
            {t("account:plan_info")}
          </Typography>
          {subscriptions.length > 0 ? (
            subscriptionList
          ) : (
            <SubscriptionDisplay type="NONE" />
          )}
        </Grid>
        <Grid xs={0.75}></Grid>
      </Grid>
      <Grid container xs={12} marginTop={2}>
        <Grid xs={0.75}></Grid>
        <Grid xs={10.5} className="white">
          <Typography
            variant="h5"
            align="center"
            marginLeft={"15px"}
            marginTop={"5px"}
            fontWeight={600}
          >
            {t("account:purchase_history")}
          </Typography>
        </Grid>
        <Grid xs={0.75}></Grid>
      </Grid>
    </Grid>
  );
}
